import axios from "axios";
import { useRef, useState } from "react";

import { GenericException } from "base/ui/errors";
import { LoadingOverlay, NotFoundView } from "base/ui/status";

import { UserBadge } from "../../../ui/commonUI";
import { SearchView } from "../../../ui/SearchView";

function AddVisitSearch({ delivery_route_id, onMarkVisited }) {
	const [users, setUsers] = useState(null);
	const [is_loading, setLoading] = useState(false);
	const ctx = useRef({}).current;

	const searchUsers = (search_text) => {
		ctx.search_text = search_text;
		setLoading(true);
		/* no search text -> recently active customers, same as customers list */
		const request = search_text
			? axios.post(`/api/admin/users/${delivery_route_id}?action=search`, { search_text })
			: axios.post(`/api/admin/users/${delivery_route_id}`, { cursor: "0" });
		request
			.then((resp) => {
				if (ctx.search_text !== search_text) return;
				if (resp.data.errors) {
					GenericException.showPopup(resp.data.errors);
					return;
				}
				setUsers(resp.data.users || []);
			})
			.finally(() => {
				ctx.search_text === search_text && setLoading(false);
			});
	};

	return (
		<div className="tw-relative tw-min-h-[300px]">
			{is_loading ? <LoadingOverlay /> : null}
			<div className="tw-px-4 tw-py-3 tw-border-b tw-sticky tw-top-0 tw-bg-white tw-z-10">
				<SearchView placeholder="Search by Name/Phone" onSearch={searchUsers} />
			</div>
			{users?.length === 0 && !is_loading ? (
				<NotFoundView title="No customers found" />
			) : (
				<div className="tw-divide-y">
					{(users || []).map((user) => (
						<div className="tw-px-4 tw-py-2 hflex tw-gap-4" key={user._id}>
							<UserBadge user={user} />
							<button className="btn-primary-v2 tw-flex-none" onClick={() => onMarkVisited(user)} type="button">
								Start Visit
							</button>
						</div>
					))}
				</div>
			)}
		</div>
	);
}

export default AddVisitSearch;
